var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("merchant.update_merchant_app"),
            "close-on-click-modal": false,
            visible: _vm.dialogUserVisible,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogUserVisible = $event
            },
            close: _vm.closeModal,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form-container",
              attrs: {
                model: _vm.form,
                "label-width": "150px",
                "label-position": "left",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("merchant.merchant_name"),
                    prop: "app_name",
                    required: "",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "search-frame",
                    attrs: {
                      value: _vm.merchant.merchant_name,
                      size: "small",
                      placeholder: _vm.$t("merchant.merchant_name"),
                      autocomplete: "off",
                      clearable: "",
                      disabled: _vm.isUpdateModal,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("merchant.notice_webhook"),
                    prop: "notice_webhook",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "search-frame",
                    attrs: {
                      size: "small",
                      placeholder: _vm.$t("merchant.notice_webhook"),
                      autocomplete: "off",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.notice_webhook,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "notice_webhook", $$v)
                      },
                      expression: "form.notice_webhook",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("merchant.callback_event_list") } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.event_names,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "event_names", $$v)
                        },
                        expression: "form.event_names",
                      },
                    },
                    _vm._l(_vm.eventList, function (event, index) {
                      return _c(
                        "el-checkbox",
                        { key: event, attrs: { label: event } },
                        [_vm._v(_vm._s(event + _vm.eventIsWithBr(index)) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("merchant.qrcode_webhook"),
                    prop: "qrcode_webhook",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "search-frame",
                    attrs: {
                      size: "mini",
                      placeholder: _vm.$t("merchant.qrcode_webhook"),
                      autocomplete: "off",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.qrcode_webhook,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "qrcode_webhook", $$v)
                      },
                      expression: "form.qrcode_webhook",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("merchant.transfer_webhook"),
                    prop: "transfer_webhook",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "search-frame",
                    attrs: {
                      size: "mini",
                      placeholder: _vm.$t("merchant.transfer_webhook"),
                      autocomplete: "off",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.transfer_webhook,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "transfer_webhook", $$v)
                      },
                      expression: "form.transfer_webhook",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogUserVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.listLoading },
                  on: { click: _vm.onClickSubmitBtn },
                },
                [_vm._v(_vm._s(_vm.$t("components.update")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }